import type React from 'react';
import SettingStyles from '../SettingStyle.module.scss';
import { ProfileSettingVendorUser } from '~/components/specifics/vendors/settings/profiles/ProfileSettingVendorUser';
import { ProfileSettingPassword } from '~/components/specifics/vendors/settings/profiles/ProfileSettingPassword';

export const ProfileSetting: React.FC = () => (
  <div>
    <h3 className={SettingStyles.SettingTitle}>プロフィール詳細</h3>
    <ProfileSettingVendorUser />
    <ProfileSettingPassword />
  </div>
);
